"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transport$ = exports.Transport$outboundSchema = exports.Transport$inboundSchema = void 0;
exports.transportToJSON = transportToJSON;
exports.transportFromJSON = transportFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const public_js_1 = require("./public.js");
const roadnetwork_js_1 = require("./roadnetwork.js");
/** @internal */
exports.Transport$inboundSchema = z.object({
    public: z.nullable(public_js_1.Public$inboundSchema),
    road_network: z.nullable(roadnetwork_js_1.RoadNetwork$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "road_network": "roadNetwork",
    });
});
/** @internal */
exports.Transport$outboundSchema = z.object({
    public: z.nullable(public_js_1.Public$outboundSchema),
    roadNetwork: z.nullable(roadnetwork_js_1.RoadNetwork$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        roadNetwork: "road_network",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Transport$;
(function (Transport$) {
    /** @deprecated use `Transport$inboundSchema` instead. */
    Transport$.inboundSchema = exports.Transport$inboundSchema;
    /** @deprecated use `Transport$outboundSchema` instead. */
    Transport$.outboundSchema = exports.Transport$outboundSchema;
})(Transport$ || (exports.Transport$ = Transport$ = {}));
function transportToJSON(transport) {
    return JSON.stringify(exports.Transport$outboundSchema.parse(transport));
}
function transportFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Transport$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Transport' from JSON`);
}
//# sourceMappingURL=transport.js.map